import { NumericReleaseResponseDto, NumericReleasesApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetNumericReleasesQuery implements IQueryMessage {
  static type = 'GetNumericReleasesQuery'
  type = GetNumericReleasesQuery.type

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(NumericReleasesApi)

export const getNumericReleasesQueryHandler: IQueryHandler<
  GetNumericReleasesQuery,
  IEvent<NumericReleaseResponseDto[]>
> = async () => {
  const { data } = await httpClient.get()

  return new Event(GetNumericReleasesQuery.type, data)
}
